import _ from 'lodash';
import moment from 'moment';
import environment from '../../environment';
import { ControlType, Item } from '../../workspaces/item';
import Workspace from '../../workspaces';
import templates from '../templates';

const datepicker = (() => {
    let _visible = false;
    let $dialog = null;
    let $template = null;
    const idDataPicker = '#dialog-datapicker';
    const eventCloseName = 'dialog-datapicker-close';

    const _close = () => $dialog.close();

    const _onClose = () => {
        Workspace.addAction(new Item(eventCloseName, '', ControlType.GlobalEvent));
        _visible = false;
        $dialog.destroy();
        $template.remove();
    };

    return (values = {}, options = {}, cb) => {
        if (!_.isObject(values)) {
            values = {};
        }

        if (_visible) {
            _close();
        }

        _visible = true;

        $template = $(templates('dialog-datepicker'));

        const date = {
            max: values.max || environment.get('CONFIG.FILTERS.ENDYEAR'),
            min: values.min || environment.get('CONFIG.FILTERS.STARTYEAR'),
            start: values.start || moment(environment.get('CONFIG.FILTERS.ENDYEAR')).startOf('year').toDate(),
            end: values.end || environment.get('CONFIG.FILTERS.ENDYEAR'),
            period: values.period || 0
        };

        const setDateValue = (type, value) => {
            startDate.enable(false);
            let dateValue;

            switch (type) {
            case 0:
                dateValue = moment(value).subtract(11, 'months').toDate();
                break;
            case 1:
                dateValue = moment(value).subtract(5, 'months').toDate();
                break;
            case 2:
                dateValue = moment(value).subtract(2, 'months').toDate();
                break;
            case 3:
                dateValue = moment(value).subtract(1, 'month').toDate();
                break;
            case 4:
                dateValue = moment(value).startOf('month').toDate();
                break;
            case 5:
                dateValue = moment(value).subtract(11, 'months').toDate();
                break;
            default:
                return startDate.enable(true);
            }

            if (dateValue < date.min) {
                dateValue = date.min;
            }

            date.start = dateValue;
            startDate.value(dateValue);
        };

        const onChange = (type, value) => {
            switch (type) {
            case 'startDate':
                date.start = value;
                endDate.min(value);
                break;
            case 'endDate':
                date.end = value;
                setDateValue(date.period, value);
                startDate.max(value);
                break;
            default:
                date.period = Number(value);
                setDateValue(date.period, date.end);
            }
        };

        const onSubmit = () => {
            cb(`${moment(date.start).format('MMM/YYYY')} -> ${moment(date.end).format('MMM/YYYY')}`, date);
            Workspace.addAction(new Item(`${idDataPicker}  button[type="submit"]`, '', ControlType.KendoButton));
            _close();
        };

        const dataSource = options.dataSource ||
            [
                { text: 'Anual', value: 0 },
                { text: 'Semestral', value: 1 },
                { text: 'Trimestral', value: 2 },
                { text: 'Bimestral', value: 3 },
                { text: 'Mensal', value: 4 },
                { text: 'Personalizado', value: -1 }
            ];

        $template.find('select[name="period"]').kendoDropDownList({
            dataTextField: 'text',
            dataValueField: 'value',
            dataSource,
            index: date.period,
            change: (e) => {
                onChange('period', e.sender.value());
                Workspace.addAction(new Item(`${idDataPicker} select[name="period"]`, e.sender.value(), ControlType.KendoDropDownList));
            }
        });

        $template.find('button[type="submit"]').kendoButton({
            click: onSubmit
        });

        const startDate = $template.find('input[name="startDate"]').kendoDatePicker({
            start: 'decade',
            depth: 'year',
            format: 'MMM/yyyy',
            value: date.start,
            max: date.max,
            min: date.min,
            change: (e) => {
                onChange('startDate', e.sender.value());
                Workspace.addAction(new Item(`${idDataPicker} input[name="startDate"]`, e.sender.value(), ControlType.KendoDatePicker));

            }
        }).data('kendoDatePicker');
        startDate.enable(false);

        const endDate = $template.find('input[name="endDate"]').kendoDatePicker({
            start: 'decade',
            depth: 'year',
            format: 'MMM/yyyy',
            value: date.end,
            max: date.max,
            min: date.min,
            change: (e) => {
                onChange('endDate', e.sender.value());
                Workspace.addAction(new Item(`${idDataPicker} input[name="endDate"]`, e.sender.value(), ControlType.KendoDatePicker));
            }
        }).data('kendoDatePicker');

        $template.on('submit', (e) => {
            e.preventDefault();
        });

        $dialog = $template.kendoWindow({
            width: '480px',
            resizable: false,
            draggable: true,
            visible: false,
            title: '',
            appendTo: 'body',
            close: _onClose
        }).data('kendoWindow');


        $(document).off(eventCloseName);
        $(document).on(eventCloseName, _onClose);

        $dialog.center().open();

        return $dialog;
    };
})();

export default datepicker;



// WEBPACK FOOTER //
// ./src/scripts/core/dialog/datepicker.js